/**
 * All errors, originate from back-end are build as follow:
 * error.response.data
 *
 * All errors, originate from front-end have their error message within
 * the error object. No additional properties.
 */
const exceptionMessage = {
    // message text with or without paramaters
    message: '',
    // message paramaters
    parameters: [],
    // message title
    title: '',
    variant: 'danger',
    autoHideDelay: 5000
};


/**
 * Get error object from response data
 * @param  {[type]} error [description]
 * @return {[type]}       [description]
 */
function getErrorFromResponse(response) {
    const error = {
        status: 0,
        statusText: '',
        message: '',
        parameters: [],
    };

    if (response.data) {
        if (response.data.message) {
            // V0 Api messages
            const tokens = response.data.message.split(':');
            if (tokens.length > 1) {
                error.status = parseInt(tokens[0]);
                error.statusText = tokens[1];
            }
            if (tokens.length > 2) {
                if (tokens[2] === 'parameters' && tokens.length > 3) {
                    // split parameters on a ;
                    error.parameters = tokens[3].split(';').map(p => p.trim()).filter(p => p.length > 0);
                } else {
                    // error message from NedGlobe API (untranslated message)
                    error.message = tokens[2];
                }
            }
        } else if (response.data.additionalInfo) {
            // V1 Api messages
            error.status = response.data.status;
            error.statusText = response.data.title;
            error.message = response.data.additionalInfo;
        }
    }
    return error;
}


// eslint-disable-next-line complexity
export function getErrorMessage(error) {
    const exceptionMessage = {
        parameters: null,
        error: error,
        title: '',
        message: ''
    };

    // get the status code for a NedGlobe error
    if (Object.prototype.hasOwnProperty.call(error, 'response')) {
        const errorData = getErrorFromResponse(error.response);
        exceptionMessage.parameters = [...errorData.parameters];

        // Data error (message is provided by the API)
        // This message is not translated into the current language
        if (errorData.status === 518) {
            exceptionMessage.message = errorData.message;
            exceptionMessage.title = 'errorTitleNedGlobeAPI';
        } else if (errorData.status >= 520 && errorData.status <= 529) {
            // PostreSql error codes [530..539]
            exceptionMessage.message = 'errorServerPostgreSQL';
            exceptionMessage.title = 'errorTitlePostgreSQL';
        } else if (errorData.status >= 530 && errorData.status <= 539) {
            // GeoServer error codes [520..529]
            exceptionMessage.message = 'errorServerGeoserver';
            exceptionMessage.title = 'errorTitleGeoserver';
        } else if (errorData.status >= 540 && errorData.status <= 549) {
            // NedGlobe-API error codes [540..549]
            exceptionMessage.message = 'errorApiNedGlobe';
            exceptionMessage.title = 'errorTitleNedGlobeAPI';
        } else if (errorData.status >= 550 && errorData.status <= 559) {
            // NedGlobe-WebAPI error codes [550..559]
            exceptionMessage.message = 'errorApiNedGlobeWeb';
            exceptionMessage.title = 'errorTitleWeb';
        } else if (errorData.status >= 560 && errorData.status <= 569) {
            // NedGlobe-OGC error codes [560..569]
            exceptionMessage.message = 'errorApiNedGlobeOgc';
            exceptionMessage.title = 'errorTitleOGC';
        } else if (errorData.status >= 570 && errorData.status <= 579) {
            // GeoCode error codes [570..579]
            exceptionMessage.message = 'errorApiNedGlobeGeoCode';
            exceptionMessage.title = 'errorTitleGeoCode';
        } else if (errorData.status >= 580 && errorData.status <= 589) {
            // Domain error codes [580..589]
            exceptionMessage.message = 'errorApiNedGlobeDomain';
            exceptionMessage.title = 'errorTitleDomain';
        } else if (errorData.status >= 590 && errorData.status <= 599) {
            // Job request codes [590..599]
            exceptionMessage.message = 'errorApiNedGlobeWebJob';
            exceptionMessage.title = 'errorTitleJobRequest';
        } else if (errorData.status >= 600 && errorData.status <= 610) {
            // URL connection codes [600..610]
            exceptionMessage.title = 'Url connectie fout';
            if (errorData.status === 600) {
                exceptionMessage.message = 'errorUrlConnectionError';
            } else if (errorData.status === 601) {
                exceptionMessage.message = 'errorUrlConnectionDataError';
            } else if (errorData.status === 602) {
                exceptionMessage.message = 'errorUrlConnectionRequestError';
            } else if (errorData.status === 603) {
                exceptionMessage.message = 'errorUrlConnectionMaxUsers';
            } else if (errorData.status === 604) {
                exceptionMessage.message = 'errorUrlConnectionNoBearerToken';
            } else if (errorData.status === 605) {
                exceptionMessage.message = 'errorUrlConnectionNoResponse';
            } else if (errorData.status === 606) {
                exceptionMessage.message = 'errorUrlConnectionNoConnectionRecord';
            } else {
                exceptionMessage.message = 'errorApiNedGlobeUrlConnection';
            }
        } else if (error.response.status >= 611 && error.response.status <= 629) {
            exceptionMessage.title = 'errorTitleCadaster';
            if (error.response.status === 611) {
                exceptionMessage.message = 'errorCadasterConnection';
            } else if (error.response.status === 612) {
                exceptionMessage.message = 'errorCadasterNaturalPerson';
            } else if (error.response.status === 613) {
                exceptionMessage.message = 'errorCadasterLegalPerson';
            } else if (error.response.status === 614) {
                exceptionMessage.message = 'errorCadasterPrivateLaw';
            } else if (error.response.status === 615) {
                exceptionMessage.message = 'errorCadasterPublicLaw';
            } else if (error.response.status === 616) {
                exceptionMessage.message = 'errorCadasterBusinessBeneficiary';
            } else if (error.response.status === 617) {
                exceptionMessage.message = 'errorCadasterRealEstate';
            }
        } else if (errorData.status >= 4011 && errorData.status <= 4019) {
            // NedGlobe-Authenticatie error codes [4011..4019]
            exceptionMessage.message = 'errorUnauthorized';
            exceptionMessage.title = 'errorTitleUnauthorized';
        } else if (errorData.status === 5000) {
            exceptionMessage.message = 'owsInUse';
        } else if (errorData.status === 5001) {
            exceptionMessage.message = 'owsNoJson';
        } else if (errorData.status === 5002) {
            if (exceptionMessage.parameters
                && exceptionMessage.parameters.length > 0) {
                exceptionMessage.message = 'layersNotfoundServiceType';
            } else {
                // single error uri
                exceptionMessage.message = 'layersNotfound';
            }
        } else if (errorData.status === 5003) {
            if (exceptionMessage.parameters
                && exceptionMessage.parameters.length > 0
                && exceptionMessage.parameters[0].length > 4) {
                // multiple error uri's
                exceptionMessage.message = 'errorOwsInvalidUris';
            } else {
                // single error uri
                exceptionMessage.message = 'errorOwsInvalidUri';
            }
        } else if (errorData.status === 5004) {
            exceptionMessage.message = 'errorOwsUnavailableLayers';
        } else if (errorData.status === 5010) {
            exceptionMessage.message = 'filterWhereNumericValueMissing';
        } else if (errorData.status === 5011) {
            exceptionMessage.message = 'filterWhereSysDataNoSupport';
        } else if (errorData.status === 5012) {
            exceptionMessage.message = 'feedbackMissingGenericFields';
        } else if (errorData.status === 5013) {
            exceptionMessage.message = 'layersNotfound';
        } else if (errorData.status === 5014) {
            exceptionMessage.message = 'featureTypeNotFound';
        } else if (errorData.status === 5020) {
            exceptionMessage.message = 'noDefaultPrintConfigurationFound';
        } else if (errorData.status === 5021) {
            exceptionMessage.message = 'errorGeoServerCreateAuthentication';
        } else if (errorData.status === 5032) {
            exceptionMessage.title = 'apiSettingsWrongPasswordTitle';
            exceptionMessage.message = 'apiSettingsWrongPasswordMessage';
        } else {
            exceptionMessage.message = errorData.message ?? 'errorApiNedGlobe';
            exceptionMessage.title = 'errorApiNedGlobe';
            exceptionMessage.data = error;
        }
        exceptionMessage.status = errorData.status;
    } else {
        // Error originates from front-end
        exceptionMessage.message = error;
        exceptionMessage.title = 'errorTitleGeneral';
        exceptionMessage.data = error;
    }
    return exceptionMessage;
}
